import * as React from 'react'
import { Element } from 'react-scroll'
import Slider, { CustomArrowProps } from 'react-slick'
import { Link } from 'react-router-dom'

interface Props {
}

function NextArrow(props: CustomArrowProps) {
	const { onClick } = props
	return (
		<div className="slide-btn slide-btn-right" onClick={onClick}>
			<img src="img/btn_slide_right.png" />
		</div>
	)
}

function PrevArrow(props: CustomArrowProps) {
	const { onClick } = props
	return (
		<div className="slide-btn slide-btn-left" onClick={onClick}>
			<img src="img/btn_slide_left.png" />
		</div>
	)
}

export default class WorksComponent extends React.Component<Props> {
	constructor(props: Props) {
		super(props)
	}

	render() {
		const sliderSetting = {
			dots: true,
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: true,
			autoplaySpeed: 6400,
			nextArrow: <NextArrow />,
			prevArrow: <PrevArrow />
		}

		return (
			<Element name="works" className="section" id="works">
				<div className="row">
					<div className="container">
						<div className="col-xs-12 col-sm-12 section-title-en">
							<span>WORKS</span>
						</div>
						<div className="col-xs-12 col-sm-12 section-title-ja">
							<span>「何を創るか」ではなく「何が効果的か」</span>
						</div>
						<div className="col-xs-12 col-sm-12 section-description">
							<span>包括的なドキュメントやミーティングは、そのほとんどがユーザーにとって何の意味もなく、ユーザーの課題を解決してくれるものでもありません。ドキュメントありきの仕事から脱却し、「何が効果的か」にフォーカスした支援をさせて頂きます。</span>
						</div>
						<div className="col-xs-12 col-sm-12 works-portfolio">
							<Slider {...sliderSetting}>

								<div className="portfolio">
										<div className="col-xs-12 col-sm-6 portfolio-image">
											<img src="img/ic_portfolio_01.png"/>
										</div>
										<div className="col-xs-12 col-sm-6 portfolio-info">
											<div className="col-xs-12 col-sm-12 portfolio-number">
												<p>PORTFOLIO 01</p>
											</div>
											<div className="col-xs-12 col-sm-12 works-name">
												<p>Clintal</p>
											</div>
											<div className="col-xs-12 col-sm-12 client-name">
												<p>株式会社クリンタル</p>
											</div>
											<div className="col-xs-12 col-sm-12 works-description">
												<p>株式会社クリンタルが運営するアプリ「Clintal」は"継続率 = リテンションレート"に課題がありました。その課題を解決すべく弊社でUIおよびUXを再設計しました。<br/>
												クリンタル独自のキャラクターを作ることにより親しみやすさを演出し、ユーザーがアプリを継続することによりアプリ内でポイントが溜まっていき、ポイントに応じて抽選でプレゼントが当たるいう仕組みによりハマる仕掛け=「フックモデル」を作りました。<br/>
												また、将来App Storeで取り上げられやすいよう、iOSヒューマンインターフェースガイドラインに沿い、インタラクティブなUI設計を定義しています。
												</p>
											</div>
										</div>
								</div>

								<div className="portfolio">
										<div className="col-xs-12 col-sm-6 portfolio-image">
											<img src="img/ic_portfolio_02.png"/>
										</div>
										<div className="col-xs-12 col-sm-6 portfolio-info">
											<div className="col-xs-12 col-sm-12 portfolio-number">
												<p>PORTFOLIO 02</p>
											</div>
											<div className="col-xs-12 col-sm-12 works-name">
												<p>TANOMU</p>
											</div>
											<div className="col-xs-12 col-sm-12 client-name">
												<p>株式会社Chefy</p>
											</div>
											<div className="col-xs-12 col-sm-12 works-description">
												<p>株式会社Chefyが企画/開発する「TANOMU」という卸業者と飲食店間で行われる受発注システムのUIUXを設計させて頂きました。<br/>
												同社はリーンスタートアップの概念をベースに、アジャイルで開発を進めているため、私たちはまずUXシナリオをベースに低制度のMVPを作り、そのMVPを元にユーザーテストを行いました。そこで得られた学びを次のMVPへと反映していくというサイクルを何度か繰り返し、UI設計・ビジュアルデザイン制作・スタイルガイド/パターンライブラリの定義など、一側面だけではなく、様々な側面で対話を重ねながら包括的に携わっています。
												</p>
											</div>
										</div>
								</div>

								<div className="portfolio">
										<div className="col-xs-12 col-sm-6 portfolio-image">
											<img src="img/ic_portfolio_03.png"/>
										</div>
										<div className="col-xs-12 col-sm-6 portfolio-info">
											<div className="col-xs-12 col-sm-12 portfolio-number">
												<p>PORTFOLIO 03</p>
											</div>
											<div className="col-xs-12 col-sm-12 works-name">
												<p>UnivManager</p>
											</div>
											<div className="col-xs-12 col-sm-12 client-name">
												<p>株式会社GENESIS</p>
											</div>
											<div className="col-xs-12 col-sm-12 works-description">
												<p>弊社が運営する大学生向けの時間割管理アプリ「UnivManager」は4年制大学の大学生向けに開発/運用しているアプリで、ペルソナ設計から要件定義、UIUI設計、開発までを自社で行なっております。<br/>
												累計ダウンロード数は15万超、月間アクティブユーザー数は2万超、を"ノンプロモーション"で達成しております。こうした結果を得られたのは、常にユーザーからの声に素早く的確に対応して、対話を繰り返してきたことにあると考えています。<br/>
												また、その他の競合アプリの調査やペルソナに適した要件定義、メンタルモデルの採用など、様々な角度でアプリのアップデートを行ってきたことも効果的に働いています。
												</p>
											</div>
										</div>
								</div>

							</Slider>
						</div>
						<div className="col-xs-12 col-sm-12 conversion">
							<Link to="/contacts" className="conversion-button">相談してみる（無料）</Link>
						</div>
					</div>
				</div>
			</Element>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/welcome/components/worksComponent.tsx